<template>
    <div>
        <el-page-header @back="goBack" content="碎片配置">
        </el-page-header>
        <el-card class="form-container" shadow="never">
            <el-button plain>所有物品碎片权重 :{{allWeight}}</el-button>
            <el-button plain>当前物品碎片权重 :{{totalWeight}}</el-button>
            <el-button class="sub-sub1" type="primary" @click="update">一键发布</el-button>
        </el-card>
        <el-card class="form-container" shadow="never">
            <el-table
                    :data="pieceList"
                    border
                    :fit="true">
                <el-table-column label="物品编号" prop="id"></el-table-column>
                <el-table-column label="物品名称" prop="name"></el-table-column>
                <el-table-column label="父级编号" prop="parentId"></el-table-column>
                <el-table-column label="碎片权重" align="center">
                    <template slot-scope="scope">
                        <el-input-number :min="0"  type="text" v-model="scope.row.weight">
                        </el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="门槛（视频数）" align="center">
                    <template slot-scope="scope">
                    <el-input-number :min="0"  type="text" v-model="scope.row.threshold">
                    </el-input-number>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
    import {
        getPrizePiece,
        batchConfigPiece,
        totalWeight
    } from "@/http/api";
    export default {
        name: "ConfigPiece",
        inject: ['reload'],
        data(){
            return{
            pieceList:[],
            totalWeight:0,
            updateWeight:0,
            allWeight:0,
            }
        },
        methods :{
            goBack(){
                this.$router.push({path: '/addPrize'})
            },
            update(){
                let _this = this;
                this.pieceList.forEach(function (piece) {
                    _this.updateWeight+=piece.weight;
                });

                batchConfigPiece(this.pieceList).then(resp => {
                    if (resp.data.status === 0) {
                        this.$message({
                            message: '更新成功',
                            type: 'success',
                            duration: 1000
                        });
                        this.reload();
                    }
                });
            }
        },
        created() {
            let _this = this;
            getPrizePiece(this.$store.state.prizeId).then(resp => {
                this.pieceList= resp.data.info;
                this.pieceList.forEach(function (piece) {
                        _this.totalWeight+=piece.weight
                  });
            });
            totalWeight().then(resp =>{
                this.allWeight=resp.data.info;
            })
        }
    }
</script>

<style scoped>

</style>